import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { CalpadSSIDResoultion } from './../../../../service/calpad-ssid-resolution';
import { Component, Inject, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CalpadsStudentsHistory } from 'src/app/component/children/model/calpads-students-history';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';

@Component({
    selector: 'app-view-child-ssid-history-modal',
    templateUrl: './view-child-ssid-history-modal.component.html',
    styleUrl: './view-child-ssid-history-modal.component.scss'
})
export class ViewChildSsidHistoryModalComponent implements OnInit {
    @Input() studentId!: number;

    calpadsStudentHistories: CalpadsStudentsHistory[] = [];

    isLoading: boolean = false;
    promises: Array<any> = [];

    getPropertyPipe = new GetPropertyPipe();
    cleanDatePipe = new CleanDatePipe();
    simpleDatePipe = new SimpleDatePipe();

    // Table display
    calpadsStudentHistoryDisplayedColumns: string[] = ['INQUIRY_DATE', 'STATUS', 'WINNING_TYPE', 'IDENTIFIER_VALUE', 'RESOLVED_USER', 'RESOLVED_DATE'];

    // Table results
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    regions: any[] = [];
    calpadsStudentHistoryTableDataSource: MatTableDataSource<CalpadsStudentsHistory>;

    msg: MsgModel;

    constructor(
        public dialogRef: MatDialogRef<ViewChildSsidHistoryModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private calpadSSIDResoultion: CalpadSSIDResoultion
    ) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        // Use data IDs if exists
        if (this.data) {
            this.studentId = this.data.studentId;
            this.isLoading = true;

            this.getHistoryAll();

            Promise.all(this.promises).then((res) => {
                this.updateDataSource();

                this.isLoading = false;
            });
        } else {
            this.msg = new MsgModel();
            this.msg.SUCCESS = false;
            this.msg.MSG = 'There is no child to retrieve from.';
        }
    }

    getHistoryAll() {
        let deferred = new Promise((resolve, reject) => {
            this.calpadSSIDResoultion.getHistoryAll(this.studentId).subscribe((res) => {
                if (res.calpadsStudentHistories) {
                    this.calpadsStudentHistories = res.calpadsStudentHistories.filter((hist: CalpadsStudentsHistory) => {
                        if (hist.STATUS === 'No Match' && !hist.IDENTIFIER_VALUE && !hist.RESOLVED_USER) {
                            return false;
                        }

                        if (hist.STATUS === 'Resolved' && !hist.IDENTIFIER_VALUE) {
                            return false;
                        }

                        if (
                            hist.RESOLVED_USER === 'API-Duplicate' ||
                            ((!hist.RESOLVED_USER || hist.RESOLVED_USER === '') &&
                                (!hist.IDENTIFIER_VALUE || hist.IDENTIFIER_VALUE === '') &&
                                (!hist.WINNING_TYPE || hist.WINNING_TYPE === ''))
                        ) {
                            return false;
                        }
                        return true;
                    });

                    this.cleanDates();

                    resolve(res);
                } else if (res?.msg) {
                    this.msg = res.msg;
                    resolve(res);
                } else {
                    this.msg = new MsgModel();
                    this.msg.SUCCESS = false;
                    this.msg.MSG = 'There is no SSID History for this child.';
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    cleanDates(): void {
        this.calpadsStudentHistories.forEach((history) => {
            history.INQUIRY_DATE = this.cleanDatePipe.transform(history.INQUIRY_DATE);

            history.RESOLVED_DATE = this.cleanDatePipe.transform(history.RESOLVED_DATE);
        });
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.calpadsStudentHistoryTableDataSource = new MatTableDataSource<CalpadsStudentsHistory>();
            this.calpadsStudentHistoryTableDataSource.data = this.calpadsStudentHistories;

            // Paginator
            //this.calpadsStudentHistoryTableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.calpadsStudentHistoryTableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'INQUIRY_DATE', direction: 'desc' };
            this.calpadsStudentHistoryTableDataSource.sort.active = defaultSort.active;
            this.calpadsStudentHistoryTableDataSource.sort.direction = defaultSort.direction;
            this.calpadsStudentHistoryTableDataSource.sort.sortChange.emit(defaultSort);
            this.calpadsStudentHistoryTableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.calpadsStudentHistoryTableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            setTimeout(() => {
                this.calpadsStudentHistoryTableDataSource.sort?.sortChange.emit(defaultSort);
            });
        });
    }
    // Dialog function
    closeDialog(closed: boolean) {
        this.dialogRef.close();
    }
}
